export const fontWeights = {
  regular: '400',
  medium: '500',
  bold: '600',
  'extra-bold': '700',
  'grand-heavy': 'grand-heavy',
};
